import { render, staticRenderFns } from "./shorts-section.vue?vue&type=template&id=405113f1&scoped=true"
import script from "./shorts-section.vue?vue&type=script&lang=js"
export * from "./shorts-section.vue?vue&type=script&lang=js"
import style0 from "./shorts-section.vue?vue&type=style&index=0&id=405113f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405113f1",
  null
  
)

export default component.exports